import { IS_ROBOKASSA, STRIPE_ENABLED } from '@/lib/siteConfig';
import { useRubProvider } from '@/lib/rubProvider';

/**
 * Платёжные системы сайта ру — так же, как в оферте (п. 5): касса рублей по
 * факту (ЮKassa 1335266 или Robokassa, lib/rubProvider.js) и Stripe.
 */
export function rubPaymentsLabel(isRobokassa, stripeEnabled = STRIPE_ENABLED) {
  return `${isRobokassa ? 'Robokassa' : 'ЮKassa'}${stripeEnabled ? ' / Stripe' : ''}`;
}

/** Строка «Платежи: …» для подвалов ру. На рф ничего не выводит. */
export default function PaymentSystemsLine({ className = '', prefix = 'Платежи: ' }) {
  const rub = useRubProvider();
  if (!IS_ROBOKASSA) return null;
  return (
    <p className={className} data-testid="payment-systems-line">
      {prefix}{rubPaymentsLabel(rub.isRobokassa)}
    </p>
  );
}
